import axios from 'axios';

// Read Base URL from .env
const BASE_URL = process.env.REACT_APP_BASE_URL + '/home';

// Fetch Labs API
export const fetchLabs = async (latitude, longitude) => {
  try {
    const response = await axios.get(BASE_URL, {
   
      params: {
        latitude,
        longitude,
      },
    });
    return response.data; // Return data directly
  } catch (error) {
    console.error('Failed to fetch labs:', error);
    throw error; // Re-throw for handling
  }
};